export default [
  {
    path: '/:lang?/verify/email',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "verify-email" */ '@/views/verify/Email.vue'),
    meta: { layout: 'minimal' },
  },
];
